module.exports = __webpack_public_path__ + "static/media/no_account.5ba2fa93.svg";